import { Navigation } from "lucide-react";
import styles from "./MapHeader.module.css";

/* Map screen header component */
export function MapHeader() {
  return (
    <div className={styles.header}>
      <h2 className={styles.title}>Dublin Activities</h2>
      <span className={styles.liveBadge}>
        <Navigation size={12} /> Live GPS
      </span>
    </div>
  );
}
